namespace $ { $mol_style_attach( "bog/builderui/dialog/dialog.view.css",
 "[bog_builderui_dialog][bog_builderui_dialog_showed=\"true\"] {\n\tdisplay: flex;\n}\n"
) }